// extracted by mini-css-extract-plugin
export var formContainer = "_i9-0";
export var message = "_i9-1";